import {createAction, props} from "@ngrx/store";
import {MenuRelatedItemPayload} from "../../../../@domain/menu-related-item-payload";

export const SET_MENU_RELATED_DATA = createAction('[MENU] SET_MENU_RELATED_DATA', props<{payload: MenuRelatedItemPayload}>())
